import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { ProductCtrl }                    from './product';
import { ProductGroupFilter }             from './product.group.filter.ajs';
import { ProductGroupPipe }               from './product.group.pipe';
import { ProductHistoryCtrl }             from './product.history';
import { ProductHistoryDirective }        from './product.history.directive';
import { ProductInvoicesCtrl }            from './product.invoices';
import { ProductInvoicesDirective }       from './product.invoices.directive';
import { ProductReservedDirective }       from './product.reserved.directive';
import { ProductSerialNumbersCtrl }       from './product.serial-numbers';
import { ProductSerialNumbersDirective }  from './product.serial-numbers.directive';
import { ProductsStates }                 from './products.states.ajs';
import { ProductStockOrdersCtrl }         from './product.stock-orders';
import { ProductStockOrdersDirective }    from './product.stock-orders.directive';
import { ProductStockTakeCtrl }           from './product.stock-take';
import { ProductStockTakeDirective }      from './product.stock-take.directive';
import { ProductStockTransfersCtrl }      from './product.stock-transfers';
import { ProductStockTransfersDirective } from './product.stock-transfers.directive';
import { ReservedProductsCtrl }           from './products.reserved';

angular.module('workshop.products', [])
.config(ProductsStates)
.controller('ProductCtrl', ProductCtrl)
.controller('ProductHistoryCtrl', ProductHistoryCtrl)
.controller('ProductInvoicesCtrl', ProductInvoicesCtrl)
.controller('ProductSerialNumbersCtrl', ProductSerialNumbersCtrl)
.controller('ProductStockOrdersCtrl', ProductStockOrdersCtrl)
.controller('ProductStockTakeCtrl', ProductStockTakeCtrl)
.controller('ProductStockTransfersCtrl', ProductStockTransfersCtrl)
.controller('ReservedProductsCtrl', ReservedProductsCtrl)
.directive('productHistory', ProductHistoryDirective)
.directive('productInvoices', ProductInvoicesDirective)
.directive('productReserved', ProductReservedDirective)
.directive('productSerialNumbers', ProductSerialNumbersDirective)
.directive('productStockOrders', ProductStockOrdersDirective)
.directive('productStockTake', ProductStockTakeDirective)
.directive('productStockTransfers', ProductStockTransfersDirective)
.filter('productGroup', ProductGroupFilter)
.service('productGroupPipe', downgradeInjectable(ProductGroupPipe));